import React, { useState} from "react";
import "./Main.css";
import { ToastContainer, toast } from "react-toastify";
import axios from "../helpers/axios";
import MenuIcon from "../images/bars-solid.svg";
import CloseIcon from "../images/window-close-regular.svg";
import me from "../images/Me-removebg-preview-new.png";
import about2 from "../images/about2.png";
import A from "../images/A.png";
import achievement from "../images/achievement.png";
import cpp from "../images/c++.png";
import flask from "../images/flask.png";
import java from "../images/java.png";
import js from "../images/js.png";
import mongodb from "../images/mongodb.png";
import mysql from "../images/mysql.png";
import node from "../images/node.png";
import python from "../images/python.png";
import react from "../images/react.png";
import sklearn from "../images/sklearn.png";
import tailwind from "../images/tailwind.png";
import bootstrap from "../images/bootstrap.png";
import git from "../images/git.png";
import c from "../images/c.png";
import kotlin from "../images/kotlin.png";
import opencv from "../images/opencv.png";
import work from "../images/work.png";
import write from "../images/write-air.png";
import game from "../images/game.png";
import notes from "../images/notes.png";
import resume from "../images/resume.pdf";
import contact from "../images/contact.png";
import github from "../images/github.png";
import twitter from "../images/twitter.png";
import linkedin from "../images/linkedin.png";

export default function Navbar() {
  //We will use react hooks for toggling the menu
  const [isSideMenuOpen, setisSideMenuOpen] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const showSideMenu = () => {
    isSideMenuOpen ? setisSideMenuOpen(false) : setisSideMenuOpen(true);
  };

  const homePage = () => {
    window.location.href = "https://atharva-patil-portfolio.netlify.app/";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    axios
      .post("/", { name, email, message })
      .then((res) => {
        const { message } = res.data;
        // console.log(message);
        toast.success(message);
      })
      .catch((err) => {
        const { error } = err.response.data;
        toast.error(error);
        // console.log("Err", error);
      });
  };

  var TxtType = function (el, toRotate, period) {
    this.toRotate = toRotate;
    this.el = el;
    this.loopNum = 0;
    this.period = parseInt(period, 10) || 2000;
    this.txt = "";
    this.tick();
    this.isDeleting = false;
  };

  TxtType.prototype.tick = function () {
    var i = this.loopNum % this.toRotate.length;
    var fullTxt = this.toRotate[i];

    if (this.isDeleting) {
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

    var that = this;
    var delta = 200 - Math.random() * 100;

    if (this.isDeleting) {
      delta /= 2;
    }

    if (!this.isDeleting && this.txt === fullTxt) {
      delta = this.period;
      this.isDeleting = true;
    } else if (this.isDeleting && this.txt === "") {
      this.isDeleting = false;
      this.loopNum++;
      delta = 500;
    }

    setTimeout(function () {
      that.tick();
    }, delta);
  };

  window.onload = function () {
    var elements = document.getElementsByClassName("typewrite");
    for (var i = 0; i < elements.length; i++) {
      var toRotate = elements[i].getAttribute("data-type");
      var period = elements[i].getAttribute("data-period");
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }
    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
    document.body.appendChild(css);

    var [slider1, slider2, slider3] = document.getElementsByClassName("slider");
    var x1 = slider1.value - "1";
    var color =
      "linear-gradient(90deg, rgb(0, 179, 89)" +
      x1 +
      "%, rgb(252,252,252)" +
      x1 +
      "%)";
    slider1.style.background = color;
    var x2 = slider2.value;
    var color =
      "linear-gradient(90deg, rgb(0, 179, 89)" +
      x2 +
      "%, rgb(252,252,252)" +
      x2 +
      "%)";
    slider2.style.background = color;
    var x3 = slider3.value;
    var color =
      "linear-gradient(90deg, rgb(0, 179, 89)" +
      x3 +
      "%, rgb(252,252,252)" +
      x3 +
      "%)";
    slider3.style.background = color;
  };

  return (
    <>
      <ToastContainer />
      <div
        className="container mr-0 bg-inherit max-w-[100%] bg-mybg 
        h-full"
      >
        <div className="container w-full h-16 bg-transparent text-gray-200 flex flex-row justify-between items-center">
          <div className="brand-logo text-3xl text-teal-700  font-semi-bold  px-4 font-lobster tracking-widest">
            <button onClick={homePage}>
              <img src={A} className="lg:w-20 w-16 mt-2" />
            </button>
          </div>
          <ul className="hidden menu-list w-full text-teal-700 lg:flex justify-end lg:flex-row font-bold  font-libre mr-4">
            <li className="menu-list-item text-xl font-semi-bold px-8 hover:underline">
              <a href="#intro">About</a>
            </li>
            <li className="menu-list-item text-xl font-semi-bold px-8 hover:underline">
              <a href="#achieve">Achievements</a>
            </li>
            <li className="menu-list-item text-xl font-semi-bold px-8 hover:underline">
              <a href="#skills">Skills</a>
            </li>
            <li className="menu-list-item text-xl font-semi-bold px-8 hover:underline">
              <a href="#projects">My Projects</a>
            </li>
            <li className="menu-list-item text-xl font-semi-bold px-8 hover:underline">
              <a href="#resume">Resume</a>
            </li>
            <li className="menu-list-item text-xl font-semi-bold px-8 hover:underline">
              <a href="#contact">Contact Me</a>
            </li>
          </ul>

          <button
            onClick={() => {
              showSideMenu();
            }}
            className="lg:hidden menu-button"
          >
            {isSideMenuOpen ? (
              <img src={CloseIcon} className="w-10 h-10 px-2" alt="close"></img>
            ) : (
              <img src={MenuIcon} className="w-10 h-10 px-2" alt="menu"></img>
            )}
          </button>
          {isSideMenuOpen ? SideMenu() : ""}
        </div>
        <div
          id="about"
          className="container mx-auto
        h-screen"
        >
          {isSideMenuOpen
            ? document.getElementById("about").classList.add("mt-[250px]")
            : ""}
          {document.getElementById("about") === null
            ? ""
            : !isSideMenuOpen
            ? document.getElementById("about").classList.remove("mt-[250px]")
            : ""}
          <div className="grid lg:grid-cols-2 lg-gap-4 xs-grid-rows-2 place-content-center h-96 w-9/12 justify-items-center mx-auto">
            <div className="grid grid-rows-3 gap-0 content-center justify-items-center mt-[450px] h-48 text-xl lg:text-4xl font-libre">
              <h1 className="font-bold  align-middle">Hello people!!</h1>
              <h1 className="font-bold">I'm Atharva Patil</h1>
              <div className="lg:mr-52 mr-28">
                <p className="inline-block font-bold  mr-2 lg:mr-4">
                  I'm a{""}
                </p>
                <p className="inline-block absolute -mt-1 lg:mt-0">
                  <span className="wrap"></span>
                  <a
                    href=""
                    className="typewrite relative text-2xl lg:text-4xl font-abril text-sky-500"
                    data-period="2000"
                    data-type='[ "Developer", "Learner", "Programmer"]'
                  ></a>
                </p>
              </div>
            </div>
            <div className="lg:mt-72 w-56 lg:w-auto">
              <img src={me} />
            </div>
          </div>
        </div>
        <h1
          id="intro"
          className="mt-48 lg:mt-0 text-2xl text-center text-teal-900 font-bold font-libre"
        >
          About Me
        </h1>
        <div className="intro container mx-auto px-8 flex lg:flex-row flex-col mt-16  lg:w-[920px]">
          <img src={about2} className="lg:mr-16 w-72 lg:-mt-8" />
          <p className="font-libre lg:text-lg text-md lg:p-2 p-1 mt-5">
            I'm a Third Year Computer Engineering Undergraduate studying at
            VJTI, Mumbai. I love to develop projects in different domains, which
            can solve real-world problems. I am passionate about exploring and
            up-skilling myself. In my free time, you can find me either reading
            a book or learning about new tech.
          </p>
        </div>
        <h1
          id="achieve"
          className="mt-16 text-2xl text-center text-teal-900 font-bold font-libre"
        >
          Achievements
        </h1>
        <div className=" mt-16 lg:mt-0 grid lg:gap-0 gap-16 lg:grid-cols-2 container mx-auto justify-items-evenly h-96 ">
          <div className="bg-gradient-to-r from-teal-100 to-teal-500 container mx-auto my-auto card-1 lg:w-96 lg:h-72 w-64 border-[1px] rounded-md border-slate-900 inline-block hover:scale-105 hover:bg-none cursor-pointer hover:text-teal-700 hover:border-teal-700    drop-shadow-2xl">
            <img
              src={achievement}
              className="w-8 h-12 relative right-[14px] bottom-[14px] rotate-[30deg]"
            />
            <p className="lg:text-2xl text-lg -mt-5 font-bold font-libre container text-center p-2">
              Top 12 in HUL Hackathon
            </p>
            <p className="lg:text-lg text-md font-sans container text-center p-2 pb-4">
              It was a hackathon organised by the HUL. It consisted of 3 stages,
              and I participated in it as a team wih 2 other members. We were
              able to make it to round 3 and were among the top 12 teams.
            </p>
          </div>
          <div className="bg-gradient-to-r from-teal-100 to-teal-500 container mx-auto my-auto card-1 lg:w-96 lg:h-72 w-64 border-[1px] rounded-md border-slate-900 inline-block hover:scale-105 hover:bg-none cursor-pointer hover:text-teal-700 hover:border-teal-700 drop-shadow-2xl">
            <img
              src={achievement}
              className="w-8 h-12 relative right-[14px] bottom-[14px] rotate-[30deg]"
            />
            <p className="lg:text-2xl text-lg -mt-5 font-bold font-libre container text-center p-2">
              1st Runner-up at EscapeRoom competition
            </p>
            <p className="lg:text-lg text-md font-sans container text-center p-2 pb-4">
              It was a competition organised by the Technovanza, VJTI. It
              consisted of 3 rounds, and I participated in it as a team with 1
              other member. We were able to make it to round 3 and secured 2nd
              position in the event.
            </p>
          </div>
        </div>
        <h1
          id="skills"
          className="mt-96 lg:mt-16 text-2xl text-center text-teal-900 font-bold font-libre"
        >
          Skills
        </h1>
        <h1 className="mt-16 text-2xl text-center text-teal-600 font-bold font-poppins">
          Tech I'm known to
        </h1>
        <div class="container grid lg:grid-cols-4 mt-8 lg:gap-2 grid-cols-2 gap-4 mx-auto w-full">
          <div class="p-2">
            <div class="flex justify-center">
              <img src={cpp} alt="C++" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg mt-1 lg:mt-0">
                C++
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={python} alt="Python" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg ">
                Python
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={js} alt="JavaScript" class="h-7 lg:h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg ">
                JavaScript
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center mr-4 lg:mr-0">
              <img src={java} alt="Java" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg ">
                Java
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={node} alt="Node.js" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                Node.js
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={react} alt="React" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                React
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={tailwind} alt="Tailwind" class="h-4 lg:h-6 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                Tailwind
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={bootstrap} alt="Bootstrap" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                Bootstrap
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={flask} alt="Flask" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                Flask
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={mongodb} alt="MongoDB" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                MongoDB
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={mysql} alt="MySQL" class="h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                MySQL
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={sklearn} alt="Scikit-learn" class="h-4 lg:h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                ScikitLearn
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={git} alt="Git" class="h-6 lg:h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                Git
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={kotlin} alt="Kotlin" class="h-5 lg:h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                Kotlin
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={c} alt="C" class="h-6 lg:h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                C
              </h3>
            </div>
          </div>
          <div class="p-2">
            <div class="flex justify-center items-center">
              <img src={opencv} alt="OpenCV" class="h-6 lg:h-8 inline" />{" "}
              <h3 class="inline ml-3 lg:text-2xl font-semibold font-poppins text-lg">
                OpenCV
              </h3>
            </div>
          </div>
        </div>
        <h1 className="mt-16 text-2xl text-center text-teal-600 font-bold font-poppins">
          Domains I've worked in
        </h1>
        <div className="mt-6 flex lg:flex-row flex-col justify-center lg:ml-16">
          <img src={work} className="w-[850px] " />
          <div className="container mx-auto flex lg:mt-0 mt-12 flex-col justify-center">
            <div>
              <p className="lg:text-2xl text-center text-xl text-teal-700 font-bold font-ubuntuM">
                Full-Stack Web development
              </p>
              <div className="slidecontainer flex justify-center">
                <input
                  type="range"
                  min="1"
                  max="100"
                  value="80"
                  className="slider lg:w-56 w-48 mt-8"
                  id="myRange"
                />
              </div>
            </div>
            <div>
              <p className="mt-10 lg:text-2xl text-center text-xl text-teal-700 font-bold font-ubuntuM">
                Machine Learning
              </p>
              <div className="slidecontainer flex justify-center">
                <input
                  type="range"
                  min="1"
                  max="100"
                  value="40"
                  className="slider lg:w-56 w-48 mt-8"
                  id="myRange"
                />
              </div>
            </div>
            <div>
              <p className="mt-10 lg:text-2xl text-center text-xl text-teal-700 font-bold font-ubuntuM">
                App development
              </p>
              <div className="slidecontainer flex justify-center">
                <input
                  type="range"
                  min="1"
                  max="100"
                  value="60"
                  className="slider lg:w-56 w-48 mt-8"
                  id="myRange"
                />
              </div>
            </div>
          </div>
        </div>
        <h1
          id="projects"
          className="mt-36 lg:mt-16 text-2xl text-center text-teal-900 font-bold font-libre"
        >
          My Projects
        </h1>
        <div className="mt-10 container mx-auto flex flex-row justify-center">
          <div className="border-r-2 border-black h-[900px] w-96 container mx-auto flex flex-col justify-center mr-0">
            <div className="flex flex-row justify-around lg:mt-16">
              <p className="text-center lg:text-3xl text-xl font-lobster text-teal-600 p-1">
                Checkers
              </p>
              <p className="text-center lg:text-xl font-lobster lg:mt-3 mt-2">
                Nov 2021
              </p>
            </div>
            <div className="h-[200px] border-t-2 border-black lg:text-md text-sm">
              <p className=" p-2 text-center lg:font-libre">
                It is a checkers website where users will be able to play
                checkers against an AI agent .
              </p>
              <p className="text-center lg:font-libre text-teal-700 hover:underline">
                <a href="https://github.com/atharvapatil123/Checkers-MERN">
                  Click to read more
                </a>
              </p>
            </div>
            <div className="h-[200px] lg:mt-24 mt-10">
              <img
                src={write}
                className="lg:ml-24 ml-2 mt-10 lg:mt-0 lg:w-auto w-[180px]"
              />
            </div>
            <div className="h-[200px] border-t-0 border-black"></div>
            <div className="flex flex-row justify-around lg:mt-12">
              <p className="text-center  lg:text-3xl text-xl font-lobster text-teal-600 p-1">
                Digi-Notes
              </p>
              <p className="text-center lg:text-xl font-lobster lg:mt-3 mt-2">
                May 2021
              </p>
            </div>
            <div className="h-[200px] border-t-2 lg:mt-0 border-black  lg:text-md text-sm">
              <p className=" p-2 text-center lg:font-libre ">
                A Kotlin app which ensures storage of all notes at one place
                digitally.
              </p>
              <p className="text-center lg:font-libre text-teal-700 hover:underline">
                <a href="https://github.com/atharvapatil123/DiGi-Notes">
                  Click to read more
                </a>
              </p>
            </div>
            <div className="h-[200px] border-t-0 lg:mt-0 border-black"></div>
          </div>
          <div className="h-[700px] w-96 container mx-auto flex flex-col justify-center ml-0">
            <div className="h-[200px] mb-24">
              <img src={game} className="ml-0 lg:ml-14 lg:w-auto" />
            </div>
            <div className="flex flex-row justify-around lg:mt-12">
              <p className="text-center  lg:text-3xl text-xl font-lobster text-teal-600 p-1">
                Write Air
              </p>
              <p className="text-center lg:text-xl font-lobster lg:mt-3 mt-2">
                Oct 2021
              </p>
            </div>
            <div className="h-[200px] border-t-2 border-black lg:text-md text-sm">
              <p className=" p-2 text-center lg:font-libre ">
                WriteAIr is a website which allows users to stream their
                writing.
              </p>
              <p className="text-center lg:font-libre text-teal-700 hover:underline">
                <a href="https://github.com/atharvapatil123/WriteAIr">
                  Click to read more
                </a>
              </p>
            </div>
            <div className="h-[200px] border-b-0 border-black">
              <img
                src={notes}
                className="lg:mt-8 lg:w-[300px] ml-0 lg:ml-14 w-[190px] mt-5"
              />
            </div>
          </div>
        </div>
        <h1
          id="resume"
          className="mt-36 text-2xl text-center text-teal-900 font-bold font-libre"
        >
          Resume
        </h1>
        <div className="container mx-auto flex lg:flex-row flex-col justify-evenly">
          <a href={resume} target="_blank" className="mx-auto mt-16 ">
            <button className="container bg-gradient-to-r from-teal-200 to-teal-500 rounded-md w-48 lg:hover:bg-none cursor-pointer hover:text-teal-700 hover:border-teal-700 font-ubuntuM font-bold h-8 inline-block text-lg mx-auto drop-shadow-2xl">
              View Resume
            </button>
          </a>
          <a href={resume} download className="mx-auto mt-16 ">
            <button className="container bg-gradient-to-r from-teal-200 to-teal-500 rounded-md w-48 lg:hover:bg-none cursor-pointer hover:text-teal-700 hover:border-teal-700 font-ubuntuM font-bold h-8 inline-block  text-lg mx-auto drop-shadow-2xl">
              Download
            </button>
          </a>
        </div>
        <h1
          id="contact"
          className="mt-48 text-2xl text-center text-teal-900 font-bold font-libre"
        >
          Contact Me
        </h1>
        <h1
          id="contact"
          className="mt-8 lg:mt-8 lg:text-xl text-lg text-center text-teal-500 font-lobster"
        >
          Your message is just a click away!
        </h1>
        {/* <ToastContainer /> */}
        <div>
          <form>
            <div className="flex lg:flex-row flex-col justify-center h-auto">
              <img src={contact} className="lg:w-[400px]" />
              <div className="flex flex-col p-10 lg:w-[850px] lg:text-lg text-sm font-libre">
                <div className="flex lg:flex-row flex-col">
                  <div className="container mx-auto lg:text-center">
                    <label for="name" className="lg:p-5 xs:mr-5">
                      Name
                    </label>
                    <input
                      id="name"
                      name="name"
                      type="name"
                      className="lg:p-1.5 bg-transparent focus:bg-white hover:bg-white border-2 rounded-md border-teal-700 outline-none  mt-1 lg:mt-0 w-60 xs:h-8 lg:h-auto lg:w-auto"
                      onChange={(e) => setName(e.target.value)}
                      value={name}
                    />
                  </div>
                  <div className="container mx-auto mt-5 lg:mt-0 lg:text-center">
                    <label for="name" className="lg:p-5 xs:mr-5">
                      Email
                    </label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      className="lg:p-1.5 p-[1px] bg-transparent focus:bg-white hover:bg-white  border-2 rounded-md border-teal-700 outline-none mt-1 lg:mt-0 w-60 xs:h-8 lg:h-auto lg:w-auto"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                  </div>
                </div>
                <div className="container mt-16 flex flex-col lg:flex-row justify-around">
                  <label for="message" className="lg:p-5 p-1 my-auto lg:mr-12">
                    Write your message here
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    type="text"
                    className="lg:w-96 h-36 bg-transparent focus:bg-white hover:bg-white  border-2 rounded-md border-teal-700 outline-none p-2"
                    onChange={(e) => setMessage(e.target.value)}
                    value={message}
                  />
                </div>
                <div className="flex justify-center">
                  <button
                    className="w-36 h-8 mt-16 bg-gradient-to-r from-teal-200 to-teal-500 rounded-md  lg:hover:bg-none cursor-pointer hover:text-teal-700 hover:border-teal-700 drop-shadow-2xl lg:p-1 "
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div
          id="contact"
          className="mt-48 lg:mt-16 lg:h-12 grid lg:grid-cols-3 grid-rows-3 gap-0 h-[120px] lg:h-30 bg-teal-700 text-sm text-center text-white font-libre justify-around"
        >
          <div className="lg:mt-4 p-2 lg:p-0">
            Copyright 2021. All rights reserved.
          </div>
          <div className="lg:mt-4 p-2 lg:p-0">
            Made using React, Tailwind and NodeJs
          </div>
          <div className="lg:mt-4 p-2 lg:p-0">
            <div className="flex flex-row justify-center">
              <a href="https://github.com/atharvapatil123">
                {" "}
                <img src={github} className="w-6 h-6 -mt-1 mr-5" />{" "}
              </a>
              <a href="https://twitter.com/Atharva30546695">
                {" "}
                <img src={twitter} className="w-6 h-6 -mt-1 mr-3" />
              </a>
              <a href="https://www.linkedin.com/in/atharva-patil-9476771a5/">
                {" "}
                <img src={linkedin} className="w-9 h-9 -mt-3" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

function SideMenu() {
  return (
    <div className="absolute h-68 w-full lg:hidden bg-teal-100 top-16">
      <ul className="menu-list flex flex-col text-xl text-center text-teal-700 font-bold font-libre ">
        <a href="#intro">
          <li className="menu-list-item py-2 hover:bg-teal-700 hover:text-teal-300">
            About
          </li>
        </a>
        <a href="#achieve">
          <li className="menu-list-item py-2 hover:bg-teal-700 hover:text-teal-300">
            Achivements
          </li>
        </a>
        <a href="#skills">
          <li className="menu-list-item py-2 hover:bg-teal-700 hover:text-teal-300">
            Skills
          </li>
        </a>
        <a href="#projects">
          <li className="menu-list-item py-2 hover:bg-teal-700 hover:text-teal-300">
            My Projects
          </li>
        </a>
        <a href="#resume">
          <li className="menu-list-item py-2 hover:bg-teal-700 hover:text-teal-300">
            Resume
          </li>
        </a>
        <a href="#contact">
          <li className="menu-list-item py-2 hover:bg-teal-700 hover:text-teal-300">
            Contact Me
          </li>
        </a>
      </ul>
    </div>
  );
}
